// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.9.0",
  date: "2026-09-11T07:54:52.516Z",
  gitInfo: {
    dirty: false,
    raw: "774cec93a",
    hash: "774cec93a",
    distance: null,
    tag: null,
    semver: null,
    suffix: "774cec93a",
    semverString: null
  }
};
/* tslint:enable */
